<template>
  <div class="home-page-wrapper">
    <HeroBanner
      image-url-present
      :title="recruitByType.title"
      :image-url="generateImageUrl(recruitByType.image)"
    />
    <Social />
    <GettingStarted :data="formattedGettingStartedContent" />
    <SectionDivider
      v-if="!loggedIn"
      title="HAVEN'T CREATED A TNA PROFILE YET?"
      :description="recruitByType.getStartedBanner"
      :link="recruitByType.getStartedBannerLink"
    />
    <SpecificFeatures :data="formattedCoachFeaturesByType" />
    <SectionDivider
      v-if="!loggedIn"
      title="CONTACT US TO KNOW MORE!"
      :description="recruitByType.coachGetStartedBanner"
      :link="recruitByType.coachGetStartedBannerLink"
      btntext="Contact Us"
    />
    <GreatFeatures :data="formattedFeaturesByType" />
  </div>
</template>

<script>
import HeroBanner from "@/pageComponents/globalUi/hero-banner";
import GettingStarted from "@/pageComponents/recruiting-101/getting-started";
import GreatFeatures from "@/pageComponents/recruiting-101/great-features";
import SpecificFeatures from "@/pageComponents/recruiting-101/specific-features";
import SectionDivider from "@/pageComponents/globalUi/section-divider";
import Social from '@/pageComponents/social/Social'
import { Base } from "@/models";
import { mapGetters } from "vuex";

import { GreatFeaturesData, CoachSpecificData } from "./data";

const MISC_STORE_KEY = "miscStore";

export default {
  name: "CollegeRecruiting",
  components: {
    HeroBanner,
    GettingStarted,
    GreatFeatures,
    SpecificFeatures,
    SectionDivider,
    Social
  },
  data() {
    return {
      CoachSpecificContent: CoachSpecificData,
      GreatFeaturesContent: GreatFeaturesData
    };
  },
  computed: {
    ...mapGetters({
      recruitByType: `${MISC_STORE_KEY}/recruitByType`,
      recruitByTypeLoading: `${MISC_STORE_KEY}/recruitByTypeLoading`,
      gettingStartedByType: `${MISC_STORE_KEY}/gettingStartedByType`,
      formattedGettingStartedContent: `${MISC_STORE_KEY}/formattedGettingStartedContent`,
      formattedCoachFeaturesByType: `${MISC_STORE_KEY}/formattedCoachFeaturesByType`,
      formattedFeaturesByType: `${MISC_STORE_KEY}/formattedFeaturesByType`
    }),
    loggedIn() {
      return Base.isLoggedIn();
    }
  },
  mounted() {
    this.$store.dispatch(`${MISC_STORE_KEY}/getResourceByType`, {
      type: "college",
      resourceName: "recruit101bytype",
      storeKey: "recruitByType",
      commitType: "show"
    });
    this.$store.dispatch(`${MISC_STORE_KEY}/getResourceByType`, {
      type: "college",
      resourceName: "gettingstartedbytype",
      storeKey: "gettingStartedByType",
      commitType: "indexUnwrapped"
    });
    this.$store.dispatch(`${MISC_STORE_KEY}/getResourceByType`, {
      type: "college",
      resourceName: "viewcoachfunctionalitybytype",
      storeKey: "coachFeaturesByType",
      commitType: "indexUnwrapped"
    });
    this.$store.dispatch(`${MISC_STORE_KEY}/getResourceByType`, {
      type: "college",
      resourceName: "viewfeaturesbytype",
      storeKey: "featuresByType",
      commitType: "indexUnwrapped"
    });
  }
};
</script>

<style lang="scss"></style>
